import { EnvironmentUrls, Endpoints } from 'Roblox';
import { httpService } from 'core-utilities';
import { REACTIVATION_CACHE_UPDATE_WAIT } from './constants';

const reactivateAccountUrl = `${EnvironmentUrls.userModerationApi}/v1/not-approved/reactivate`;

const reactivateAccount = async (setIsLoading: (value: boolean) => void): Promise<unknown> => {
  setIsLoading(true);
  const urlConfig: { url: string; withCredentials: boolean } = {
    url: reactivateAccountUrl,
    withCredentials: true
  };
  const result = httpService.post(urlConfig).then(() => {
    setTimeout(() => {
      // Sleep here to make sure cache is purged and we get the correct state:
      // https://roblox.slack.com/archives/C04N3DMALTZ/p1717449493064619?thread_ts=1717434570.758779&cid=C04N3DMALTZ
      const url = Endpoints.getAbsoluteUrl('/');
      window.location.href = url;
    }, REACTIVATION_CACHE_UPDATE_WAIT);
  });
  return result;
};

export default reactivateAccount;
